import React from 'react';
import { motion } from 'framer-motion';
import './WeatherDisplay.css';

function WeatherDisplay({ weather }) {
  // Иконка погоды
  const getWeatherIcon = (condition) => {
    const icons = {
      'Clear': '☀️',
      'Clouds': '☁️',
      'Rain': '🌧️',
      'Snow': '❄️',
      'Thunderstorm': '⛈️',
      'Drizzle': '🌦️',
      'Mist': '🌫️'
    };
    return icons[condition] || '🌍';
  };

  return (
    <motion.div 
      className="weather-display"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
    >
      {/* Заголовок с городом */}
      <div className="weather-header">
        <span className="weather-icon">{getWeatherIcon(weather.weather)}</span>
        <h2 className="weather-city glitch">{weather.city}</h2>
      </div>
      
      {/* Таблица с данными */}
      <div className="weather-table">
        <div className="weather-row">
          <span className="weather-label">ТЕМПЕРАТУРА:</span>
          <span className="weather-value">{weather.temp}°C</span>
        </div>
        
        <div className="weather-row">
          <span className="weather-label">ОЩУЩАЕТСЯ КАК:</span>
          <span className="weather-value">{weather.feels_like}°C</span>
        </div>
        
        <div className="weather-row">
          <span className="weather-label">ВЛАЖНОСТЬ:</span>
          <span className="weather-value">{weather.humidity}%</span>
        </div>
        
        <div className="weather-row">
          <span className="weather-label">ДАВЛЕНИЕ:</span>
          <span className="weather-value">{weather.pressure} hPa</span>
        </div>
        
        <div className="weather-row">
          <span className="weather-label">ВЕТЕР:</span>
          <span className="weather-value">{weather.wind} м/с</span>
        </div>
        
        <div className="weather-row">
          <span className="weather-label">ОБЛАЧНОСТЬ:</span>
          <span className="weather-value">{weather.description}</span>
        </div>
      </div>
      
      {/* Доп информация */}
      <div className="weather-footer">
        <div className="weather-coords">
          <span>КООРДИНАТЫ: {weather.lat}°, {weather.lon}°</span>
        </div>
        <div className="weather-time">
          <span>ДАННЫЕ АКТУАЛЬНЫ НА: {new Date().toLocaleTimeString()}</span>
        </div>
      </div>
    </motion.div>
  );
}

export default WeatherDisplay;